import type { SearchType } from 'src/types/search';

const PLURAL = {
  package: ['Тур', 'туры'],
  hotel: ['Предложение', 'предложения'],
};

export const getPluralOffersType = (
  type: SearchType,
  isPlural: boolean,
): string => PLURAL[type][isPlural ? 1 : 0];

export const getTextForSimilarFail = (
  isHotelOnly: boolean,
  hasAdjustParams: boolean,
): { title: string; description: string } => {
  if (isHotelOnly) {
    return hasAdjustParams
      ? {
          title: 'Не нашлось похожих номеров',
          description:
            'К сожалению на эти даты не нашлось похожих номеров.\nПопробуйте поискать на другие даты, либо воспользуйтесь\nтекущим предложением',
        }
      : {
          title: 'Чуть-чуть не успели!',
          description:
            'Похоже, все выбранные номера уже раскупили.\nПосмотрим, что ещё осталось?',
        };
  }

  return hasAdjustParams
    ? {
        title: 'Не нашлось похожих туров',
        description:
          'К сожалению на эти даты не нашлось похожих туров.\nПопробуйте поискать на другие даты, либо воспользуйтесь\nтекущим предложением',
      }
    : {
        title: 'Чуть-чуть не успели!',
        description:
          'Похоже, все такие туры уже раскупили.\nПосмотрим, что ещё осталось?',
      };
};
